import { Field } from 'factorial-form'
import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import BaseNumberField from 'modules/core/components/NumberField'

interface Props {
  dataSchemaItem: DataSchemaItemFragment
  field: Field
}

export const NumberField = observer(({ dataSchemaItem, field }: Props) => {
  const value = field.value ? Number(field.value) : null
  return (
    <BaseNumberField
      label={dataSchemaItem.label}
      mandatory={dataSchemaItem.required}
      placeholder={dataSchemaItem.label}
      step={1}
      value={value}
      onChange={(newValue) => field.set(String(newValue))}
      textAlign="left"
    />
  )
})
